/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedBlurbPcs_vipUserRelationship$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarBlurbs_vipUserRelationship$ref: FragmentReference;
export type PdpRespSidebarBlurbs_vipUserRelationship = {|
  +$fragmentRefs: PdpSharedBlurbPcs_vipUserRelationship$ref,
  +$refType: PdpRespSidebarBlurbs_vipUserRelationship$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarBlurbs_vipUserRelationship",
  "type": "UserRelationship",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedBlurbPcs_vipUserRelationship",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1cf8265b48aa8d1f45d27e1f5bfad332';
module.exports = node;
